// Lookup to translate country codes to the country name that ActionKit requires when an action is
// submitted
export const akCountries = {
  AF: {
    name: 'Afghanistan',
    value: 'Afghanistan'
  },
  AX: {
    name: 'Åland Islands',
    value: 'Aland Islands'
  },
  AL: {
    name: 'Albania',
    value: 'Albania'
  },
  DZ: {
    name: 'Algeria',
    value: 'Algeria'
  },
  AS: {
    name: 'American Samoa',
    value: 'American Samoa'
  },
  AD: {
    name: 'Andorra',
    value: 'Andorra'
  },
  AO: {
    name: 'Angola',
    value: 'Angola'
  },
  AI: {
    name: 'Anguilla',
    value: 'Anguilla'
  },
  AQ: {
    name: 'Antarctica',
    value: 'Antarctica'
  },
  AG: {
    name: 'Antigua and Barbuda',
    value: 'Antigua and Barbuda'
  },
  AR: {
    name: 'Argentina',
    value: 'Argentina'
  },
  AM: {
    name: 'Armenia',
    value: 'Armenia'
  },
  AW: {
    name: 'Aruba',
    value: 'Aruba'
  },
  AU: {
    name: 'Australia',
    value: 'Australia'
  },
  AT: {
    name: 'Austria',
    value: 'Austria'
  },
  AZ: {
    name: 'Azerbaijan',
    value: 'Azerbaijan'
  },
  BS: {
    name: 'Bahamas',
    value: 'Bahamas'
  },
  BH: {
    name: 'Bahrain',
    value: 'Bahrain'
  },
  BD: {
    name: 'Bangladesh',
    value: 'Bangladesh'
  },
  BB: {
    name: 'Barbados',
    value: 'Barbados'
  },
  BY: {
    name: 'Belarus',
    value: 'Belarus'
  },
  BE: {
    name: 'Belgium',
    value: 'Belgium'
  },
  BZ: {
    name: 'Belize',
    value: 'Belize'
  },
  BJ: {
    name: 'Benin',
    value: 'Benin'
  },
  BM: {
    name: 'Bermuda',
    value: 'Bermuda'
  },
  BT: {
    name: 'Bhutan',
    value: 'Bhutan'
  },
  BO: {
    name: 'Bolivia',
    value: 'Bolivia'
  },
  BQ: {
    name: 'Bonaire, Sint Eustatius and Saba',
    value: 'Bonaire, Sint Eustatius and Saba'
  },
  BA: {
    name: 'Bosnia and Herzegovina',
    value: 'Bosnia and Herzegovina'
  },
  BW: {
    name: 'Botswana',
    value: 'Botswana'
  },
  BV: {
    name: 'Bouvet Island',
    value: 'Bouvet Island'
  },
  BR: {
    name: 'Brazil',
    value: 'Brazil'
  },
  IO: {
    name: 'British Indian Ocean Territory',
    value: 'British Indian Ocean Territory'
  },
  BN: {
    name: 'Brunei',
    value: 'Brunei'
  },
  BG: {
    name: 'Bulgaria',
    value: 'Bulgaria'
  },
  BF: {
    name: 'Burkina Faso',
    value: 'Burkina Faso'
  },
  BI: {
    name: 'Burundi',
    value: 'Burundi'
  },
  CV: {
    name: 'Cabo Verde',
    value: 'Cabo Verde'
  },
  KH: {
    name: 'Cambodia',
    value: 'Cambodia'
  },
  CM: {
    name: 'Cameroon',
    value: 'Cameroon'
  },
  CA: {
    name: 'Canada',
    value: 'Canada'
  },
  KY: {
    name: 'Cayman Islands',
    value: 'Cayman Islands'
  },
  CF: {
    name: 'Central African Republic',
    value: 'Central African Republic'
  },
  TD: {
    name: 'Chad',
    value: 'Chad'
  },
  CL: {
    name: 'Chile',
    value: 'Chile'
  },
  CN: {
    name: 'China',
    value: 'China'
  },
  CX: {
    name: 'Christmas Island',
    value: 'Christmas Island'
  },
  CC: {
    name: 'Cocos (Keeling) Islands',
    value: 'Cocos (Keeling) Islands'
  },
  CO: {
    name: 'Colombia',
    value: 'Colombia'
  },
  KM: {
    name: 'Comoros',
    value: 'Comoros'
  },
  CG: {
    name: 'Congo',
    value: 'Congo'
  },
  CD: {
    name: 'Congo (the Democratic Republic of the)',
    value: 'Congo (the Democratic Republic of the)'
  },
  CK: {
    name: 'Cook Islands',
    value: 'Cook Islands'
  },
  CR: {
    name: 'Costa Rica',
    value: 'Costa Rica'
  },
  CI: {
    name: "Côte d'Ivoire",
    value: "Cote d'Ivoire"
  },
  HR: {
    name: 'Croatia',
    value: 'Croatia'
  },
  CU: {
    name: 'Cuba',
    value: 'Cuba'
  },
  CW: {
    name: 'Curaçao',
    value: 'Curacao'
  },
  CY: {
    name: 'Cyprus',
    value: 'Cyprus'
  },
  CZ: {
    name: 'Czechia',
    value: 'Czech Republic'
  },
  DK: {
    name: 'Denmark',
    value: 'Denmark'
  },
  DJ: {
    name: 'Djibouti',
    value: 'Djibouti'
  },
  DM: {
    name: 'Dominica',
    value: 'Dominica'
  },
  DO: {
    name: 'Dominican Republic',
    value: 'Dominican Republic'
  },
  EC: {
    name: 'Ecuador',
    value: 'Ecuador'
  },
  EG: {
    name: 'Egypt',
    value: 'Egypt'
  },
  SV: {
    name: 'El Salvador',
    value: 'El Salvador'
  },
  GQ: {
    name: 'Equatorial Guinea',
    value: 'Equatorial Guinea'
  },
  ER: {
    name: 'Eritrea',
    value: 'Eritrea'
  },
  EE: {
    name: 'Estonia',
    value: 'Estonia'
  },
  ET: {
    name: 'Ethiopia',
    value: 'Ethiopia'
  },
  FK: {
    name: 'Falkland Islands  [Malvinas]',
    value: 'Falkland Islands'
  },
  FO: {
    name: 'Faroe Islands',
    value: 'Faroe Islands'
  },
  FJ: {
    name: 'Fiji',
    value: 'Fiji'
  },
  FI: {
    name: 'Finland',
    value: 'Finland'
  },
  FR: {
    name: 'France',
    value: 'France'
  },
  GF: {
    name: 'French Guiana',
    value: 'French Guiana'
  },
  PF: {
    name: 'French Polynesia',
    value: 'French Polynesia'
  },
  TF: {
    name: 'French Southern Territories',
    value: 'French Southern Territories'
  },
  GA: {
    name: 'Gabon',
    value: 'Gabon'
  },
  GM: {
    name: 'Gambia',
    value: 'Gambia'
  },
  GE: {
    name: 'Georgia',
    value: 'Georgia'
  },
  DE: {
    name: 'Germany',
    value: 'Germany'
  },
  GH: {
    name: 'Ghana',
    value: 'Ghana'
  },
  GI: {
    name: 'Gibraltar',
    value: 'Gibraltar'
  },
  GR: {
    name: 'Greece',
    value: 'Greece'
  },
  EL: {
    name: 'Greece',
    value: 'Greece'
  },
  GL: {
    name: 'Greenland',
    value: 'Greenland'
  },
  GD: {
    name: 'Grenada',
    value: 'Grenada'
  },
  GP: {
    name: 'Guadeloupe',
    value: 'Guadeloupe'
  },
  GU: {
    name: 'Guam',
    value: 'Guam'
  },
  GT: {
    name: 'Guatemala',
    value: 'Guatemala'
  },
  GG: {
    name: 'Guernsey',
    value: 'Guernsey'
  },
  GN: {
    name: 'Guinea',
    value: 'Guinea'
  },
  GW: {
    name: 'Guinea-Bissau',
    value: 'Guinea-Bissau'
  },
  GY: {
    name: 'Guyana',
    value: 'Guyana'
  },
  HT: {
    name: 'Haiti',
    value: 'Haiti'
  },
  HM: {
    name: 'Heard Island and McDonald Islands',
    value: 'Heard Island and McDonald Islands'
  },
  VA: {
    name: 'Holy See',
    value: 'Vatican'
  },
  HN: {
    name: 'Honduras',
    value: 'Honduras'
  },
  HK: {
    name: 'Hong Kong',
    value: 'Hong Kong'
  },
  HU: {
    name: 'Hungary',
    value: 'Hungary'
  },
  IS: {
    name: 'Iceland',
    value: 'Iceland'
  },
  IN: {
    name: 'India',
    value: 'India'
  },
  ID: {
    name: 'Indonesia',
    value: 'Indonesia'
  },
  IR: {
    name: 'Iran',
    value: 'Iran'
  },
  IQ: {
    name: 'Iraq',
    value: 'Iraq'
  },
  IE: {
    name: 'Ireland',
    value: 'Ireland'
  },
  IM: {
    name: 'Isle of Man',
    value: 'Isle of Man'
  },
  IL: {
    name: 'Israel',
    value: 'Israel'
  },
  IT: {
    name: 'Italy',
    value: 'Italy'
  },
  JM: {
    name: 'Jamaica',
    value: 'Jamaica'
  },
  JP: {
    name: 'Japan',
    value: 'Japan'
  },
  JE: {
    name: 'Jersey',
    value: 'Jersey'
  },
  JO: {
    name: 'Jordan',
    value: 'Jordan'
  },
  KZ: {
    name: 'Kazakhstan',
    value: 'Kazakhstan'
  },
  KE: {
    name: 'Kenya',
    value: 'Kenya'
  },
  KI: {
    name: 'Kiribati',
    value: 'Kiribati'
  },
  XK: {
    name: 'Kosovo',
    value: 'Kosovo'
  },
  KW: {
    name: 'Kuwait',
    value: 'Kuwait'
  },
  KG: {
    name: 'Kyrgyzstan',
    value: 'Kyrgyzstan'
  },
  LA: {
    name: 'Laos',
    value: 'Laos'
  },
  LV: {
    name: 'Latvia',
    value: 'Latvia'
  },
  LB: {
    name: 'Lebanon',
    value: 'Lebanon'
  },
  LS: {
    name: 'Lesotho',
    value: 'Lesotho'
  },
  LR: {
    name: 'Liberia',
    value: 'Liberia'
  },
  LY: {
    name: 'Libya',
    value: 'Libya'
  },
  LI: {
    name: 'Liechtenstein',
    value: 'Liechtenstein'
  },
  LT: {
    name: 'Lithuania',
    value: 'Lithuania'
  },
  LU: {
    name: 'Luxembourg',
    value: 'Luxembourg'
  },
  MO: {
    name: 'Macao',
    value: 'Macao'
  },
  MK: {
    name: 'Macedonia',
    value: 'Macedonia'
  },
  MG: {
    name: 'Madagascar',
    value: 'Madagascar'
  },
  MW: {
    name: 'Malawi',
    value: 'Malawi'
  },
  MY: {
    name: 'Malaysia',
    value: 'Malaysia'
  },
  MV: {
    name: 'Maldives',
    value: 'Maldives'
  },
  ML: {
    name: 'Mali',
    value: 'Mali'
  },
  MT: {
    name: 'Malta',
    value: 'Malta'
  },
  MH: {
    name: 'Marshall Islands',
    value: 'Marshall Islands'
  },
  MQ: {
    name: 'Martinique',
    value: 'Martinique'
  },
  MR: {
    name: 'Mauritania',
    value: 'Mauritania'
  },
  MU: {
    name: 'Mauritius',
    value: 'Mauritius'
  },
  YT: {
    name: 'Mayotte',
    value: 'Mayotte'
  },
  MX: {
    name: 'Mexico',
    value: 'Mexico'
  },
  FM: {
    name: 'Micronesia (Federated States of)',
    value: 'Micronesia'
  },
  MD: {
    name: 'Moldova',
    value: 'Moldova'
  },
  MC: {
    name: 'Monaco',
    value: 'Monaco'
  },
  MN: {
    name: 'Mongolia',
    value: 'Mongolia'
  },
  ME: {
    name: 'Montenegro',
    value: 'Montenegro'
  },
  MS: {
    name: 'Montserrat',
    value: 'Montserrat'
  },
  MA: {
    name: 'Morocco',
    value: 'Morocco'
  },
  MZ: {
    name: 'Mozambique',
    value: 'Mozambique'
  },
  MM: {
    name: 'Myanmar',
    value: 'Myanmar'
  },
  NA: {
    name: 'Namibia',
    value: 'Namibia'
  },
  NR: {
    name: 'Nauru',
    value: 'Nauru'
  },
  NP: {
    name: 'Nepal',
    value: 'Nepal'
  },
  NL: {
    name: 'Netherlands',
    value: 'Netherlands'
  },
  NC: {
    name: 'New Caledonia',
    value: 'New Caledonia'
  },
  NZ: {
    name: 'New Zealand',
    value: 'New Zealand'
  },
  NI: {
    name: 'Nicaragua',
    value: 'Nicaragua'
  },
  NE: {
    name: 'Niger',
    value: 'Niger'
  },
  NG: {
    name: 'Nigeria',
    value: 'Nigeria'
  },
  NU: {
    name: 'Niue',
    value: 'Niue'
  },
  NF: {
    name: 'Norfolk Island',
    value: 'Norfolk Island'
  },
  KP: {
    name: 'North Korea',
    value: 'North Korea'
  },
  MP: {
    name: 'Northern Mariana Islands',
    value: 'Northern Mariana Islands'
  },
  NO: {
    name: 'Norway',
    value: 'Norway'
  },
  OM: {
    name: 'Oman',
    value: 'Oman'
  },
  PK: {
    name: 'Pakistan',
    value: 'Pakistan'
  },
  PW: {
    name: 'Palau',
    value: 'Palau'
  },
  PS: {
    name: 'Palestine, State of',
    value: 'Palestine'
  },
  PA: {
    name: 'Panama',
    value: 'Panama'
  },
  PG: {
    name: 'Papua New Guinea',
    value: 'Papua New Guinea'
  },
  PY: {
    name: 'Paraguay',
    value: 'Paraguay'
  },
  PE: {
    name: 'Peru',
    value: 'Peru'
  },
  PH: {
    name: 'Philippines',
    value: 'Philippines'
  },
  PN: {
    name: 'Pitcairn',
    value: 'Pitcairn'
  },
  PL: {
    name: 'Poland',
    value: 'Poland'
  },
  PT: {
    name: 'Portugal',
    value: 'Portugal'
  },
  PR: {
    name: 'Puerto Rico',
    value: 'Puerto Rico'
  },
  QA: {
    name: 'Qatar',
    value: 'Qatar'
  },
  RE: {
    name: 'Réunion',
    value: 'Reunion'
  },
  RO: {
    name: 'Romania',
    value: 'Romania'
  },
  RU: {
    name: 'Russia',
    value: 'Russia'
  },
  RW: {
    name: 'Rwanda',
    value: 'Rwanda'
  },
  BL: {
    name: 'Saint Barthélemy',
    value: 'St. Barthelemy'
  },
  SH: {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    value: 'St. Helena'
  },
  KN: {
    name: 'Saint Kitts and Nevis',
    value: 'St. Kitts-Nevis'
  },
  LC: {
    name: 'Saint Lucia',
    value: 'St. Lucia'
  },
  MF: {
    name: 'Saint Martin (French part)',
    value: 'St. Martin'
  },
  PM: {
    name: 'Saint Pierre and Miquelon',
    value: 'St. Pierre and Miquelon'
  },
  VC: {
    name: 'Saint Vincent and the Grenadines',
    value: 'St. Vincent and the Grenadines'
  },
  WS: {
    name: 'Samoa',
    value: 'Samoa'
  },
  SM: {
    name: 'San Marino',
    value: 'San Marino'
  },
  ST: {
    name: 'Sao Tome and Principe',
    value: 'Sao Tome and Principe'
  },
  SA: {
    name: 'Saudi Arabia',
    value: 'Saudi Arabia'
  },
  SN: {
    name: 'Senegal',
    value: 'Senegal'
  },
  RS: {
    name: 'Serbia',
    value: 'Serbia'
  },
  SC: {
    name: 'Seychelles',
    value: 'Seychelles'
  },
  SL: {
    name: 'Sierra Leone',
    value: 'Sierra Leone'
  },
  SG: {
    name: 'Singapore',
    value: 'Singapore'
  },
  SX: {
    name: 'Sint Maarten (Dutch part)',
    value: 'Sint Maarten'
  },
  SK: {
    name: 'Slovakia',
    value: 'Slovakia'
  },
  SI: {
    name: 'Slovenia',
    value: 'Slovenia'
  },
  SB: {
    name: 'Solomon Islands',
    value: 'Solomon Islands'
  },
  SO: {
    name: 'Somalia',
    value: 'Somalia'
  },
  ZA: {
    name: 'South Africa',
    value: 'South Africa'
  },
  GS: {
    name: 'South Georgia and the South Sandwich Islands',
    value: 'South Georgia and the South Sandwich Islands'
  },
  KR: {
    name: 'South Korea',
    value: 'South Korea'
  },
  SS: {
    name: 'South Sudan',
    value: 'South Sudan'
  },
  ES: {
    name: 'Spain',
    value: 'Spain'
  },
  LK: {
    name: 'Sri Lanka',
    value: 'Sri Lanka'
  },
  SD: {
    name: 'Sudan',
    value: 'Sudan'
  },
  SR: {
    name: 'Suriname',
    value: 'Suriname'
  },
  SJ: {
    name: 'Svalbard and Jan Mayen',
    value: 'Svalbard and Jan Mayen'
  },
  SZ: {
    name: 'Swaziland',
    value: 'Swaziland'
  },
  SE: {
    name: 'Sweden',
    value: 'Sweden'
  },
  CH: {
    name: 'Switzerland',
    value: 'Switzerland'
  },
  SY: {
    name: 'Syria',
    value: 'Syria'
  },
  TW: {
    name: 'Taiwan',
    value: 'Taiwan'
  },
  TJ: {
    name: 'Tajikistan',
    value: 'Tajikistan'
  },
  TZ: {
    name: 'Tanzania',
    value: 'Tanzania'
  },
  TH: {
    name: 'Thailand',
    value: 'Thailand'
  },
  TL: {
    name: 'Timor-Leste',
    value: 'Timor-Leste'
  },
  TG: {
    name: 'Togo',
    value: 'Togo'
  },
  TK: {
    name: 'Tokelau',
    value: 'Tokelau'
  },
  TO: {
    name: 'Tonga',
    value: 'Tonga'
  },
  TT: {
    name: 'Trinidad and Tobago',
    value: 'Trinidad and Tobago'
  },
  TN: {
    name: 'Tunisia',
    value: 'Tunisia'
  },
  TR: {
    name: 'Turkey',
    value: 'Turkey'
  },
  TM: {
    name: 'Turkmenistan',
    value: 'Turkmenistan'
  },
  TC: {
    name: 'Turks and Caicos Islands',
    value: 'Turks and Caicos Islands'
  },
  TV: {
    name: 'Tuvalu',
    value: 'Tuvalu'
  },
  UG: {
    name: 'Uganda',
    value: 'Uganda'
  },
  UA: {
    name: 'Ukraine',
    value: 'Ukraine'
  },
  AE: {
    name: 'United Arab Emirates',
    value: 'United Arab Emirates'
  },
  GB: {
    name: 'United Kingdom',
    value: 'United Kingdom'
  },
  UM: {
    name: 'United States Minor Outlying Islands',
    value: 'United States Minor Outlying Islands'
  },
  US: {
    name: 'United States of America',
    value: 'USA'
  },
  UY: {
    name: 'Uruguay',
    value: 'Uruguay'
  },
  UZ: {
    name: 'Uzbekistan',
    value: 'Uzbekistan'
  },
  VU: {
    name: 'Vanuatu',
    value: 'Vanuatu'
  },
  VE: {
    name: 'Venezuela',
    value: 'Venezuela'
  },
  VN: {
    name: 'Vietnam',
    value: 'Vietnam'
  },
  VG: {
    name: 'Virgin Islands (British)',
    value: 'Virgin Islands, British'
  },
  VI: {
    name: 'Virgin Islands (U.S.)',
    value: 'Virgin Islands, U.S.'
  },
  WF: {
    name: 'Wallis and Futuna',
    value: 'Wallis and Futuna'
  },
  EH: {
    name: 'Western Sahara',
    value: 'Western Sahara'
  },
  YE: {
    name: 'Yemen',
    value: 'Yemen'
  },
  ZM: {
    name: 'Zambia',
    value: 'Zambia'
  },
  ZW: {
    name: 'Zimbabwe',
    value: 'Zimbabwe'
  }
}

const EU_COUNTRY_CODES = {
  AT: true,
  BE: true,
  BG: true,
  CY: true,
  CZ: true,
  DE: true,
  DK: true,
  EE: true,
  FI: true,
  FR: true,
  EL: true, // Greece
  GR: true, // Also Greece?
  HR: true,
  HU: true,
  IE: true,
  IT: true,
  LV: true,
  LT: true,
  LU: true,
  MT: true,
  NL: true,
  PL: true,
  PT: true,
  RO: true,
  SK: true,
  SI: true,
  ES: true,
  SE: true,
  GB: true // TODO: Delete this line after Brexit
}

// Pass in a country code and this will return whether the country is part of the EU
export const isEu = code => !!EU_COUNTRY_CODES[code.toUpperCase()]

const LGPD_COUNTRY_CODES = {
  BR: true
}

export const isLgpd = code => !!LGPD_COUNTRY_CODES[code.toUpperCase()]

// Fields that should be hidden if a particular country is selected
const COUNTRY_FIELDS_BLACKLIST = {
  postal_code: [
    'AF',
    'AL',
    'AO',
    'AI',
    'AR',
    'AW',
    'BS',
    'BB',
    'BZ',
    'BJ',
    'BT',
    'BO',
    'BW',
    'BR',
    'BI',
    'KY',
    'CF',
    'TD',
    'CL',
    'CN',
    'CO',
    'KM',
    'CK',
    'CR',
    'CU',
    'DM',
    'EC',
    'SV',
    'GQ',
    'ER',
    'EE',
    'FO',
    'FJ',
    'GM',
    'GY',
    'HN',
    'HK',
    'IE',
    'JM',
    'KI',
    'LR',
    'LI',
    'MW',
    'MR',
    'MU',
    'MX',
    'MC',
    'MS',
    'MZ',
    'MM',
    'NR',
    'NC',
    'NI',
    'NE',
    'KP',
    'MP',
    'PW',
    'PA',
    'PY',
    'PE',
    'RE',
    'RW',
    'WS',
    'SM',
    'SC',
    'SL',
    'SO',
    'ZA',
    'SR',
    'TJ',
    'TZ',
    'TG',
    'TO',
    'TM',
    'TV',
    'UG',
    'VU',
    'VE',
    'VN',
    'ZM',
    'ZW'
  ]
}

// Fields that should be revealed if a particular country is selected
const COUNTRY_FIELDS_WHITELIST = {}

// Takes an array of fieldConfigs items [field_name, field_label] and a countryCode value and
// returns a modified array according to the blacklist and whitelist rules above
export const getCountryPermittedFields = (fields, countryCode) =>
  fields
    .map(fieldConfig => {
      if (
        COUNTRY_FIELDS_WHITELIST[fieldConfig[0]] &&
        COUNTRY_FIELDS_WHITELIST[fieldConfig[0]].find(code => code === countryCode)
      ) {
        // Alright we're whitelisting the fieldConfig, just return it.
        return fieldConfig
      }

      if (
        COUNTRY_FIELDS_WHITELIST[fieldConfig[0]] &&
        !COUNTRY_FIELDS_WHITELIST[fieldConfig[0]].find(code => code === countryCode)
      ) {
        // This fieldConfig is not whitelisted for the countryCode so return null
        return null
      }

      if (
        COUNTRY_FIELDS_BLACKLIST[fieldConfig[0]] &&
        COUNTRY_FIELDS_BLACKLIST[fieldConfig[0]].find(code => code === countryCode)
      ) {
        // This fieldConfig is blacklisted for the countryCode, return null
        return null
      }

      // All tests pass. Return the fieldConfig
      return fieldConfig
    })
    .filter(fieldConfig => fieldConfig)
